<template>
	<div class="container independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 检查管理
			</div>
			<div class="container-left">
				<div class="left-con">
					<div class="center">
						<div class="tips">注意事项</div>
						<p class="tip">为增加检查的准确性，在舌面检查前，请注意以下事项：</p>
						<div class="line">
							<p class="yellow">
								<span>1、光线</span>
								<img src="../../../static/images/yellowbg.png" />
							</p>
							<p>确保检查环境有足够的光线，可以选择明亮的环境或使用适当的照明设备，以提高检查的准确性。</p>
						</div>
						<div class="line">
							<p class="yellow">						
								<span>2、姿势</span>
								<img src="../../../static/images/yellowbg.png" />
							</p>
							<p>
								引导就诊者取正坐姿势，放松面部，取下面部遮蔽物，如眼镜、饰品等。
								在拍摄舌象图片时，舌伸三分之一出口外，避免舌体紧张、卷曲、过分用力或伸舌时间过长，
								以免影响舌体血液循环而出现假象。
							</p>
						</div>
						<div class="line">
							<p class="yellow">
								<span>3、饮食</span>
								<img src="../../../static/images/yellowbg.png" />								
							</p>
							<p>请确保就诊者检查前一段时间内，未进食或饮食染色剂含量高的食物或饮料，以确保本体舌色的清晰可见，避免干扰结果判断。</p>
						</div>
						<div class="line">
							<p class="yellow">
								<span>4、其他舌面症状</span>
								<img class="img" src="../../../static/images/yellowbg.png" />								
							</p>
							<p>在使用舌面仪前，请询问就诊者有无任何舌面问题或症状，例如溃疡、疼痛或肿胀等。若就诊者有相关症状，建议等症状消除后再进行测量，或在测量结果后进行人工结论校准。</p>
						</div>
					</div>
					<div class="bottom">
						<div class="btn" @click="startInspection">开始检查</div>
					</div>
				</div>
			</div>
			<div class="container-right">
				<div class="right-con">
					<div class="search-con">
						<el-input class="input" v-model="searchData" placeholder="请输入内容"></el-input>
						<el-button style="margin-right:8px;margin-bottom: 10px;" class="search addBtn" type="primary"
							@click="onSearchData">搜索</el-button>
						<el-button style="margin-left: 0;" class="search addBtn refresh" @click="tabRefresh">刷新
						</el-button>
					</div>

					<div class="tab" v-if="tabActiveIndex == 1">
						<ul>
							<li :class="tabIndex == index ? 'active' : ''" v-for="(item, index) in tabList" :key="index"
								@click="tabClick(index)">
								{{ item }}
							</li>
						</ul>
					</div>
					<div class="list" :style="{ marginTop: tabActiveIndex == 0 ? '20px' : '50px' }">
						<ul v-if="userList.length == 0 && userListFlag && tabIndex == 0">
							<li class="noData">暂无数据</li>
						</ul>
						<ul v-if="auxiliaryUserList.length == 0 && userListFlag && tabIndex == 1">
							<li class="noData">暂无数据</li>
						</ul>
						<ul v-if="userList.length > 0 && tabIndex == 0">
							<li v-for="(item, index) in userList" :key="item.id"
								:class="userIndex == index ? 'active' : ''" @click="selectUser(index, item.id)">
								<div class="one">
									<span class="name">
										{{ item.name }}
									</span>
									<span>({{ item.gender }} {{ item.age }}岁 )</span>
								</div>
								<div class="two">
									<img src="../../../static/images/pluse/time.png" />
									<span>添加时间：{{ item.createTime }}</span>
								</div>
								<i v-if="userIndex == index" @click="editUser(item)"
									class="positionRight el-icon-arrow-right">
									编辑
								</i>
							</li>
						</ul>
						<ul v-if="auxiliaryUserList.length > 0 && tabIndex == 1">
							<li v-for="(item, index) in auxiliaryUserList" :key="item.vvid"
								:class="userIndex == index ? 'active' : ''" @click="selectUser(index, item.vvid, item)">
								<div class="one">
									<span class="name">
										{{ item.pnam }}
									</span>
									<span>({{ item.psex }} {{ item.age }}岁 )</span>
								</div>
								<i class="positionRight el-icon-arrow-right"></i>
							</li>
						</ul>
						<div class="des" v-if="userList.length > 10 && tabActiveIndex == 0">
							<div class="right" v-if="totalPage > 1">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
										:page-size="10" layout="pager" :total="total">
									</el-pagination>
								</div>
							</div>
						</div>
					</div>
					<div class="bottom" v-show="tabIndex == 0">
						<el-button type="" @click="addUser">
							<el-icon class="el-icon--right">
								<Plus />
							</el-icon>添加患者
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog title="新增患者信息" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item class="width150" label="患者姓名" prop="name">
									<el-input v-model="addUserForm.name"></el-input>
								</el-form-item>
								<el-form-item style="width:120px" class="width150 marginLeft" label="患者性别" prop="sex">
									<el-select v-model="addUserForm.sex" placeholder="请选择性别">
										<el-option label="男" value="男"></el-option>
										<el-option label="女" value="女"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="line">
								<el-form-item class="width150" label="手机号码" prop="phone">
									<el-input v-model="addUserForm.phone"></el-input>
								</el-form-item>
								<!-- <el-form-item class="width150 marginLeft" label="出生日期" prop="date">
									<el-date-picker class="addUserFormDate" v-model="addUserForm.date"
										value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
										:picker-options="pickerOptions0" placeholder="选择日期时间">
									</el-date-picker>
								</el-form-item> -->
								<el-form-item class="width150 marginLeft" label="年龄" prop="date">
									<el-input v-model="addUserForm.date" @blur="blurAge"></el-input>
									<span style="margin-left: 30px;">岁</span>
								</el-form-item>
							</div>
							<div class="line">
								<el-form-item class="width150" label="身份证号" prop="pID">
									<el-input v-model="addUserForm.pID"></el-input>
								</el-form-item>
								<el-form-item class="width150 marginLeft" label="邮箱地址" prop="email">
									<el-input v-model="addUserForm.email"></el-input>
								</el-form-item>
							</div>

						</div>
					</el-form>
				</div>
				<template class="dialog-footer footer" #footer>

					<el-button @click="cancelPatient">取 消</el-button>
					<el-button class="addBtn" type="primary" @click="addPatient('addUserForm')">保 存</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	const util = require("../../../static/js/util.js");

	export default {
		data() {
			return {
				faceList: [{
						url: require('../../../static/images/face/shezhen.png'),
						name: '舌诊',
						txt: '从舌象',
						action: '看身体'
					},
					{
						url: require('../../../static/images/face/mianzhen.png'),
						name: '面诊',
						txt: '从脸色',
						action: '看五脏健康'
					},
				],
				faceListIndex: -1,
				tabList: ["本地患者", "辅诊患者"],
				tabIndex: 0,
				searchData: "",
				userList: [], //用户列表
				auxiliaryUserList: [], //辅诊用户列表
				userListFlag: false,
				userIndex: -1, //用户选择索引
				patientId: "", //患者id
				addUserFlag: false,
				addOrEdit: 'add',
				addUserForm: {
					name: "",
					sex: "",
					phone: "",
					date: "",
					pID: "",
					email: "",
					prov: "",
					city: "",
					sub: "",
					id: ''
				},
				rules: {
					name: [{
						required: true,
						message: "请输入患者姓名",
						trigger: "blur",
					}, ],
					sex: [{
						required: true,
						message: "请选择患者性别",
						trigger: "change",
					}, ],
					phone: [{
						required: true,
						message: "请输入手机号码",
						trigger: "blur",
					}, ],
					date: [{
						required: true,
						validator: this.validateAge,
						trigger: "blur",
					}, ],
				},
				pickerOptions0: {
					disabledDate(time) {
						return time.getTime() > Date.now() - 8.64e6;
					},
				},
				currentPage: 1, //当前页
				totalPage: 1, //总页数
				total: 0, //总数据
				tabActiveIndex: 0,
				loginInfo: {},
				selectUserInfo: {},
				vvId: "",
				visitId: '',
				birthDate: ''
			};
		},
		methods: {
			//舌面切换
			faceClick(index) {
				this.faceListIndex = index;
				localStorage.setItem('faceListIndex', this.faceListIndex)
			},
			//开始检查
			startInspection() {
				if (this.tabIndex == 0) {
					if (this.patientId == "") {
						this.$message.error("请选择患者");
						return false;
					}
				}
				if (this.tabIndex == 1) {
					if (this.vvId == "") {
						this.$message.error("请选择患者");
						return false;
					}

				}
				sessionStorage.setItem("reset",true);
				this.getVisitInfo();
			},
			//获取就诊信息
			getVisitInfo(type) {
				this.$applicationJson('/business/visit/info/add', {
					"patientId": this.patientId, //患者id
					'outVisitId': this.vvId
				}).then(
					res => {
						//console.log(res)
						if (res.data.code == 0) {
							if (res.data.data) {
								this.visitId = res.data.data;
								this.$message.warning('舌面采集功能已移除');
							}
						}
					}
				).catch(Error => {
					this.$message.error('网络异常');
				})
			},
			//添加患者
			addUser() {
				this.addUserFlag = true;
				this.addOrEdit = 'add';
				this.addUserForm = {
					name: "",
					sex: "",
					phone: "",
					date: "",
					pID: "",
					email: "",
					prov: "",
					city: "",
					sub: "",
				};
				this.$nextTick(() => {
					this.$refs.addUserForm.resetFields();
				});
			},
			//新增用户
			addPatient(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addOrEdit == 'add') {
							this.addUserInfo();
						} else {
							this.editUserInfo();
						}

					} else {
						return false;
					}
				});
			},
			//年龄正则验证
			validateAge(rule, age, callback) {
				const ageRegex = /^(0?[1-9]|[1-9][0-9]|[1][0-1][0-9]|120)$/;
				if (age === "") {
					callback(new Error("请输入年龄"));
				} else if (!ageRegex.test(age)) {
					callback(new Error("年龄格式不正确"));
				} else {
					callback();
				}
			},
			//根据年龄计算出生日期
			calculateBirthDate() {
				const currentDate = new Date(); // 当前日期
				const currentYear = currentDate.getFullYear();
				const birthYear = currentYear - this.addUserForm.date;
				const birthDate = new Date(
					birthYear,
					currentDate.getMonth(),
					currentDate.getDate()
				);
				this.birthDate = birthDate.toISOString().substring(0, 10); // 格式化为 YYYY-MM-DD
			},
			getAge(teacherBirthday) {
				let birthdays = new Date(teacherBirthday.replace(/-/g, "/"));
				let d = new Date();
				let age =
			 	d.getFullYear() -
					birthdays.getFullYear() -
					(d.getMonth() < birthdays.getMonth() ||
						(d.getMonth() == birthdays.getMonth() &&
							d.getDate() < birthdays.getDate()) ?
						1 :
						0);

				this.addUserForm.date = age;
			},

			// 年龄输入框失去焦点
			blurAge() {
				this.calculateBirthDate();
			},
			// 添加本地用户
			addUserInfo() {
				this.$applicationJson("/business/patient/add", {
						name: this.addUserForm.name,
						gender: this.addUserForm.sex,
						phone: this.addUserForm.phone,
						birth: this.birthDate,
						idNumber: this.addUserForm.pID,
						email: this.addUserForm.email,
						address: "",
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getUserList();
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑
			editUserInfo() {
				this.$applicationJson("/business/patient/edit", {
						name: this.addUserForm.name,
						gender: this.addUserForm.sex,
						phone: this.addUserForm.phone,
						birth: this.birthDate,
						idNumber: this.addUserForm.pID,
						email: this.addUserForm.email,
						id: this.addUserForm.id
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getUserList();
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//搜索
			onSearchData() {
				if (this.tabActiveIndex == 0) {
					this.getUserList();
				}
				if (this.tabActiveIndex == 1) {
					this.getAuxiliaryUserList();
				}
			},
			//tab刷新 本地患者  辅诊患者
			tabRefresh() {
				this.searchData = '';
				if (this.tabIndex == 0) {
					this.getUserList();
				}
				if (this.tabIndex == 1) {
					this.getAuxiliaryUserList();
				}
			},
			//tab切换 本地患者  辅诊患者
			tabClick(index) {
				this.tabIndex = index;
				//this.tabActiveIndex = index;
				if (this.tabIndex == 0) {
					this.userList = [];
					this.getUserList();
				}
				if (this.tabIndex == 1) {
					this.auxiliaryUserList = [];
					this.getAuxiliaryUserList();
				}
				localStorage.setItem("tabIndex", this.tabIndex);
			},
			//获取用户列表
			getUserList() {
				this.$applicationJson("/business/patient/paging", {
						current: this.currentPage,
						orderBy: "",
						params: {
							q: this.searchData,
						},
						size: 10,
					})
					.then((res) => {
						// console.log(res)
						if (res.data.code == 0) {
							this.userList = res.data.data.records;
							if (this.userList.length == 0) {
								this.userListFlag = true;
							} else {
								for (let i = 0; i < this.userList.length; i++) {
									this.userList[i].age = "";
									var birthdays = new Date(
										this.userList[i].birth.replace(/-/g, "/")
									);
									var d = new Date();
									var age =
										d.getFullYear() -
										birthdays.getFullYear() -
										(d.getMonth() < birthdays.getMonth() ||
											(d.getMonth() == birthdays.getMonth() &&
												d.getDate() < birthdays.getDate()) ?
											1 :
											0);
									this.userList[i].age = age;
								}
							}
							this.totalPage = res.data.data.pages;
							this.total = res.data.data.total;
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取辅诊患者列表
			getAuxiliaryUserList() {
				this.$applicationJson("/docking/visit/list", {
						empId: this.loginInfo.outId,
						hosId: this.loginInfo.outHospitalId,
						outToken: this.loginInfo.outToken,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.auxiliaryUserList = res.data.data.recList;
							this.totalPage = res.data.data.pages;
							this.total = res.data.data.total;
							if (this.auxiliaryUserList.length == 0) {
								this.userListFlag = true;
							} else {
								for (let i = 0; i < this.auxiliaryUserList.length; i++) {
									var birthdays = new Date(
										this.auxiliaryUserList[i].pbirth.replace(/-/g, "/")
									);
									var d = new Date();
									var age =
										d.getFullYear() -
										birthdays.getFullYear() -
										(d.getMonth() < birthdays.getMonth() ||
											(d.getMonth() == birthdays.getMonth() &&
												d.getDate() < birthdays.getDate()) ?
											1 :
											0);
									this.auxiliaryUserList[i].age = age;
								}
							}
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//分页处理
			handleCurrentChange(val) {
				this.currentPage = val;
				if (this.tabActiveIndex == 0) {
					this.getUserList();
				}
			},
			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},
			//选择病人
			selectUser(index, id, item) {
				this.userIndex = index;
				this.selectUserInfo = item;
				if (this.tabIndex == 0) {
					this.patientId = id;
				}
				if (this.tabIndex == 1) {
					this.vvId = id;
				}
			},
			editUser(item) {
				this.addOrEdit = 'edit';
				this.$applicationJson("/business/patient/detail", {
						id: item.id
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = true;
							this.addUserForm.name = res.data.data.name;
							this.addUserForm.sex = res.data.data.gender;
							this.addUserForm.phone = res.data.data.phone;
							this.getAge(res.data.data.birth);
							this.birthDate = res.data.data.birth;
							this.addUserForm.pID = res.data.data.idNumber
							this.addUserForm.email = res.data.data.email;
							this.addUserForm.id = res.data.data.id;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			}
		},
		created() {
			this.$nextTick(() => {
				this.tabActiveIndex = localStorage.getItem("tabActiveIndex");
				this.tabIndex = this.tabActiveIndex;
				this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let location = this.$route.query.part; //左右手
				if (location) {
					this.form.location = location;
				}
				if (this.tabActiveIndex == 0) {
					this.getUserList();
				}
				if (this.tabActiveIndex == 1) {
					this.getAuxiliaryUserList();
				}
			});
		},
		mounted() {},
	};
</script>

<style scoped="scoped" lang="less">
	.container {
		width: 100%;
		height: 100%;
		background: #f5f5f5;

		.content {
			height: calc(100% - 40px);
			width: calc(100% - 80px);
			margin-left: 40px;

			.title {
				width: 100%;
				height: 40px;
				line-height: 40px;
			}
		}

		.container-left {
			width: calc(78% - 10px);
			background-color: #fff;
			box-shadow: 0px 2px 11px 6px rgb(192 204 230);
			float: left;
			margin-left: 0px;
			border-radius: 8px;
			height: calc(100% - 10px);
			position: relative;

			.left-con {
				//width: 360px;
				margin: 20px auto;
				//text-align: center;

				@media (min-width: 880px) {
					margin: 30px auto;
				}

				@media (min-width: 1280px) {
					margin: 50px auto;
				}

				@media (min-width: 1480px) {
					margin: 60px auto;
				}

				@media (min-width: 1920px) {
					margin-top: 10%;
				}

				.center {
					width: 80%;
					margin: 0 auto;

					//display: flex;
					.tips {
						font-weight: bold;
						font-size: 24px;
						color: #679FF6;
						text-align: center;
						width: 100%;
						display: block;
					}

					.tip {
						font-size: 14px;
						margin-top: 30px;
						margin-bottom: 18px;
					}

					.line {
						width: 100%;
						margin-top: 18px;

						p {
							font-size: 14px;
							line-height: 20px;

							&:nth-child(1) {
								font-weight: bold;
								margin-bottom: 5px;
							}
						}
						.yellow{
							position: relative;
							height: 20px;
							span{
								    position: absolute;
								    top: 0px;
									z-index: 2;
							}
							img{
								position:absolute;
								bottom: 2px;
								width: 53px;
							}
							.img{
								width: 108px;
							}
						}
					}

					.face-con {
						flex: 1;
						justify-content: center;
						align-items: center;
						cursor: pointer;
						padding: 20px;

						&.active {
							background: #f9f9f9;
						}

						img {
							width: 240px;
							margin: 0 auto;
						}

						.face {
							font-size: 40px;
							font-family: 49--Regular, 49-;
							font-weight: 400;
							color: #13171D;
							line-height: 72px;
						}

						p {
							font-weight: 400;
							color: #4C5159;
							line-height: 20px;
							font-size: 16px;

							&.fontS {
								font-size: 14px;
								line-height: 20px;
							}
						}
					}
				}

				.bottom {
					width: 100%;
					margin-top: 80px;
					position: absolute;
					bottom: 20px;

					.btn {
						width: 280px;
						height: 50px;
						background: #679FF6;
						border-radius: 4px;
						text-align: center;
						line-height: 50px;
						font-size: 16px;
						margin: 0 auto;
						color: #fff;
						cursor: pointer;
					}
				}
			}
		}

		.container-right {
			width: calc(22%);
			background-color: #fff;
			box-shadow: 0px 2px 11px 6px rgb(192 204 230);
			height: 100%;
			float: right;
			margin-right: 0px;
			position: relative;
			border-radius: 8px;
			height: calc(100% - 10px);

			.right-con {
				width: 100%;
				margin: 10px auto;

				.search-con {
					margin-left: 5%;
					width: 95%;

					@media (min-width: 1200px) {
						width: 95%;
					}

					@media (min-width: 1480px) {
						width: 95%;
					}

					@media (min-width: 1920px) {
						width: 90%;
					}

					overflow: hidden;

					.input {
						float: left;
						width: 36%;

						@media (min-width: 1200px) {
							width: 46%;
						}

						@media (min-width: 1480px) {
							width: 54%;
						}

						@media (min-width: 1920px) {
							width: 64%;
						}
					}

					.search {
						float: left;
					}

					:deep(.el-input__inner) {
						width: 100%;
						border-right: 0px;
						border-radius: 5px 0 0px 5px;
					}

					.el-button {
						border-radius: 0;
						border-left: 0;
						padding: 0px 10px;
						height: 42px;
						line-height: 42px;
						border-radius: 0px 5px 5px 0px;

						@media (min-width: 1920px) {
							padding: 12px;
						}
					}

					.refresh {
						color: #333;
						background-color: #fff;
						border: 1px solid #eee;
						float: left;
						border-radius: 5px;
					}
				}

				.tab {
					width: 100%;
					margin-top: 10px;
					float: left;

					ul {
						width: 90%;
						margin-left: 5%;
						height: 30px;
						line-height: 30px;

						li {
							padding: 0 10px;
							float: left;
							font-size: 14px;
							color: rgb(141, 143, 149);

							&.active {
								color: rgb(19, 23, 29);
							}
						}
					}
				}

				.list {
					margin-top: 60px;
					width: 100%;
					height: calc(100% - 180px);
					overflow-y: auto;
					position: absolute;
					float: left;

					ul {
						width: 90%;
						margin-left: 5%;
						height: calc(100% - 60px);

						li {
							width: 100%;
							border: 1px solid #eee;
							border-radius: 5px;
							margin-bottom: 5px;
							position: relative;

							&.active {
								border: 1px solid #4e8fea;
							}

							.one {
								width: 95%;
								padding: 15px 0 15px 0px;
								margin-left: 10px;
								overflow: hidden;
							}

							.one {
								span {
									display: inline-block;
									float: left;
									font-size: 14px;
								}

								.name {
									font-weight: bold;
									display: inline-block;
									max-width: 100px;
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}
							}

							.two {
								width: 95%;
								margin-left: 10px;
								padding: 0px 0 15px 0;

								img {
									float: left;
									width: 16px;
									margin-right: 5px;
									margin-top: 1px;
								}

								span {
									display: inline-block;
									width: calc(100% - 21px);
								}
							}

							.positionRight {
								position: absolute;
								right: 10px;
								top: 22px;
								font-size: 16px;
								margin-top: -8px;
								font-size: 14px;
								cursor: pointer;
								color: #4e8fea;
							}
						}

						.noData {
							border: none;
							text-align: center;
							color: #999;
						}
					}

					.des {
						width: 100%;
						background: #fff;
						float: left;
						height: 60px;
						text-align: center;

						.right {
							width: 100%;
							text-align: right;
							margin-right: 0px;

							.page {
								text-align: right;
								width: 98%;
							}
						}
					}
				}

				.list {
					scrollbar-width: none;
				}

				.list::-webkit-scrollbar {
					width: 0;
				}

				.bottom {
					width: 160px;
					position: absolute;
					left: 50%;
					bottom: 14px;
					margin-left: -80px;

					.el-button {
						width: 100%;
						margin: 0 auto;
						height: 40px;
						line-height: 40px;
					}
				}
			}
		}
	}

	.dialog {
		.el-dialog__body {
			.con {
				width: 100%;
				margin-top: 30px;
				height: 200px;


				.item {
					.line {
						.width150 {
							:deep(.el-input) {
								width: 150px;
							}

							:deep(.el-input__inner) {
								width: 150px;
							}

							:deep(.el-select) {
								width: 130px;
							}

						}

						:deep(.el-input__inner) {
							height: 32px;
							line-height: 32px;
						}

						.marginLeft {
							margin-left: 50px;
						}
					}
				}
			}
		}
	}

	.el-dialog__footer .footer {
		text-align: right;
		display: inline-block;
		width: calc(100% - 0px);
	}
</style>
